export type ProgramLanguageType = 'JAVA' | 'CPP' | 'PYTHON' | 'JAVASCRIPT';

export const programLanguageTypeTextMap: Record<ProgramLanguageType, string> = {
  JAVA: 'java',
  CPP: 'cpp',
  PYTHON: 'python',
  JAVASCRIPT: 'javascript',
};
